import React from 'react';
import PropTypes from 'prop-types';
import PreviewButton from 'SignatureManager/PreviewButton';

const StaticBuilderSignatureManagerPreviewButton = props => (
  <PreviewButton
    id="signAnyDocBtn"
    className="btn btn-success btn-large save-use-btn success-btn"
    click={props.handleSignClick}
    text="Sign Any Document"
    isVisible={false}
  />
);

StaticBuilderSignatureManagerPreviewButton.propTypes = {
  imageUrls: PropTypes.shape({
    draw: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  handleSignClick: PropTypes.func.isRequired,
};

export default StaticBuilderSignatureManagerPreviewButton;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderSignatureManager/PreviewButton.jsx